import React from "react";
import NavMenu from "./nav";

const DEFAULT_NAV_CONFIG = { initialIsCollapsed: false, isIconOnly: false };

// basePath eg. "/location-analytics/";

export default function Menu({ navItems = [], navConfig = DEFAULT_NAV_CONFIG, i18nNamespace = "", i18n = null, basePath = "/", navItemClick = () => {}, disableItems = [], customClassName }) {
  return (
    <NavMenu
      navConfig={navConfig}
      navMenuItems={navItems}
      i18nNamespace={i18nNamespace}
      i18n={i18n}
      basePath={basePath}
      navItemClick={navItemClick}
      disableItems={disableItems}
      customClassName={customClassName}
    />
  );
}
